import { useEffect, useState, useCallback, Component } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Destinations from "@/components/Destinations";
import Experiences from "@/components/Experiences";
import WhyMirevaa from "@/components/WhyMirevaa";
import Inspiration from "@/components/Inspiration";
import Enquiry from "@/components/Enquiry";
import Footer from "@/components/Footer";
import AdminPage from "@/pages/AdminPage";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-ivory flex items-center justify-center px-6">
          <div className="text-center">
            <p className="font-display text-3xl text-forest">Mirevaa Journeys</p>
            <p className="mt-3 text-sm text-forest-mist">Something went wrong. Please refresh the page.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function Home({ onPlan, onNavigate, prefillDest }) {
  return (
    <>
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar onNavigate={onNavigate} onPlan={() => onPlan()} />
      <main>
        <Hero onPlan={() => onPlan()} onExplore={() => onNavigate("destinations")} />
        <Marquee />
        <About />
        <Destinations onPlanJourney={onPlan} />
        <Experiences />
        <WhyMirevaa onPlan={() => onPlan()} />
        <Inspiration />
        <Enquiry prefillDestination={prefillDest} />
      </main>
      <Footer onNavigate={onNavigate} />
    </>
  );
}

function App() {
  const [prefillDest, setPrefillDest] = useState("");

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  const scrollToId = useCallback((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) {
      window.__lenis.scrollTo(el, { duration: 1.5 });
    } else {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  const planJourney = useCallback(
    (destination = "") => {
      if (destination) setPrefillDest(destination);
      scrollToId("plan-your-journey");
    },
    [scrollToId]
  );

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/admin" element={<AdminPage />} />
          <Route
            path="*"
            element={<Home onPlan={planJourney} onNavigate={scrollToId} prefillDest={prefillDest} />}
          />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
